import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./Blog.css";
import BlogHero from "../../components/pages/Blog/BlogHero/BlogHero";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import { blogPosts } from "../../data/blogPosts";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { useBlogPosts } from "../../hooks/usePublicQueries";
import { resolveMediaUrl } from "../../utils/media";

const Blog = () => {
  const { t, i18n } = useTranslation();
  const { data: apiPosts } = useBlogPosts(i18n.language);

  const posts = useMemo(() => {
    const formatDate = (value) => {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    const mapped = [...apiPosts]
      .sort((a, b) => {
        const timeA = new Date(a?.publishedAtUtc || a?.createdAtUtc || 0).getTime();
        const timeB = new Date(b?.publishedAtUtc || b?.createdAtUtc || 0).getTime();
        return timeB - timeA;
      })
      .slice(0, 3)
      .map((post) => ({
        id: String(post?.id || ""),
        title: post?.title || "",
        desc: post?.text || post?.excerpt || post?.description || "",
        date: formatDate(post?.publishedAtUtc || post?.createdAtUtc),
        image: resolveMediaUrl(post?.imageUrl),
      }))
      .filter((post) => post.id && (post.title || post.desc || post.image));

    return mapped.length ? mapped : blogPosts.slice(0, 3);
  }, [apiPosts]);

  const visiblePosts = useMemo(() => posts.slice(0, 3), [posts]);

  return (
    <div className="blog-page">
      <Navbar theme="light" />
      <BlogHero />
      <div className="blog-page-content-guide">
        <section className="blog blog-page-posts">
          <div className="blog-container">
            <span className="blog-tag tag">{t("sections.blog.tag")}</span>
            <h2 className="blog-title">{t("sections.blog.listTitle")}</h2>
            <div className="blog-grid">
              {visiblePosts.map((post, index) => (
                <Link to={`/blog/${post.id}`} className="blog-card" key={post.id}>
                  <div className="blog-img">
                    <img src={post.image} alt={post.title} />
                  </div>

                  <div className="blog-content">
                    <span className="blog-date">{post.date}</span>
                    <h3>{post.title}</h3>
                    <p>{post.desc}</p>
                    <span className="blog-link">
                      {t("sections.blog.readArticle")} <FaArrowRight />
                    </span>
                  </div>

                  {index !== visiblePosts.length - 1 && <div className="divider" />}
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Blog;